module.exports = __webpack_public_path__ + "img/karma.6bb69dd1.svg";